<script lang="ts">
  import CheckMark from "./CheckMark.svelte";

  interface Props {
    type?: "radio" | "checkbox";
    variant?: "primary" | "secondary" | "small";
    checked?: boolean;
    required?: boolean;
    group?: any;
    value?: any;
    disabled?: boolean;
    size?: "small" | "normal";
    children?: import("svelte").Snippet;
    onChange?: () => void;
    onClick?: () => void;
  }

  let {
    type = "checkbox",
    variant = "primary",
    checked = false,
    required = false,
    group = $bindable(undefined),
    value = undefined,
    disabled = false,
    size = "normal",
    children,
    onChange = () => {},
    onClick = () => {},
  }: Props = $props();
</script>

{#if type == "checkbox"}
  <label class="checkbox-label relative {disabled ? 'pointer-events-none' : ''}">
    <input {required} onchange={onChange} onclick={onClick} type="checkbox" {checked} class="hidden-input" />
    <div class="flex text-M text-Neutral900 items-center cursor-pointer mr-4">
      <div
        data-variant={variant}
        class="{disabled
          ? 'bg-Neutral400 mr-2 flex h-8 w-8 items-center justify-center rounded-full'
          : 'checkbox'} w-8 h-8 flex-shrink-0"
        class:checked
      >
        {#if checked}
          <CheckMark />
        {/if}
      </div>
      {@render children?.()}
    </div>
  </label>
{:else}
  <label class="checkbox-label relative {disabled ? 'pointer-events-none' : ''} ">
    <input
      onchange={onChange}
      onclick={onClick}
      bind:group
      {value}
      type="radio"
      {checked}
      class="hidden-input"
    />
    <div class="flex text-M text-Neutral900 items-center cursor-pointer mr-4">
      <div
        data-variant={variant}
        class="checkbox flex-shrink-0 {checked ? 'checked' : ''}"
        class:small-box={size == "small"}
      >
        {#if checked}
          <CheckMark />
        {/if}
      </div>
      {@render children?.()}
    </div>
  </label>
{/if}
